/* eslint-disable import/no-anonymous-default-export */
export default {
	title: 'Light',

	colors: {
		primary: '#cccccc',
		secondary: '#84eafe',

		background: '#ffffff',
		text: '#1c1c1c'
	}
}
